<template>
  <div class="rich-text">
    <Toolbar class="rich-text__tool" :editor="editorRef" :mode="mode" :default-config="toolbarConfig" />
    <Editor
      class="rich-text__text"
      :style="{ height: height }"
      :defaultConfig="editorConfig"
      :mode="mode"
      v-model="vhtml"
      @onCreated="handleCreated"
    />
  </div>
</template>
<script setup>
import { ElMessage } from 'element-plus'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import { defineProps, defineEmits, ref, reactive, getCurrentInstance } from 'vue'
const props = defineProps({
  height: { type: String, default: '150px' },
  modelValue: String,
  mode: { type: String, default: 'default' }, //模式：默认 default 极简模式 simple
  placeholder: { type: String, default: '请输入内容...' },
  url: { type: String, default: '/sys/oss/upload' } //上传图片地址
})
const emit = defineEmits(['update:modelValue', 'change'])
const { proxy } = getCurrentInstance()
const editorRef = ref(null)
const toolbarConfig = reactive({})
const uploadImageList = ref([])

const getOnInsertedImage = (imageNode) => {
  uploadImageList.value.push(imageNode)
}

const update = async (file, insertFn) => {
  const formData = new FormData()
  formData.append('file', file)
  let res = await proxy.$http.post(props.url, formData, {
    headers: { 'Content-type': 'multipart/form-data' }
  })
  if (res.code === 0) {
    let { url, name } = res.data
    insertFn(url, name, url)
  } else {
    ElMessage.error('网络连接异常，请稍候再试')
  }
}

const customCheckLinkFn = (text, url) => {
  if (!url) return
  if (url.indexOf('http') !== 0) {
    ElMessage.error('链接必须以 http/https 开头')
    return '链接必须以 http/https 开头'
  }
  return true
}

const customParseLinkUrl = (url) => {
  if (url.indexOf('http') !== 0) {
    return `http://${url}`
  }
  return url
}
const editorConfig = reactive({
  placeholder: props.placeholder,
  MENU_CONF: {
    insertImage: { onInsertedImage: getOnInsertedImage() },
    uploadImage: { customUpload: update },
    insertLink: { checkLink: customCheckLinkFn, parseLinkUrl: customParseLinkUrl },
    editLink: { checkLink: customCheckLinkFn, parseLinkUrl: customParseLinkUrl }
  }
})
const handleCreated = (editor) => {
  editorRef.value = Object.seal(editor)
  let imgList = editor.getElemsByType('image')
  uploadImageList.value = JSON.parse(JSON.stringify(imgList))
}
const vhtml = ref('')
watch(
  () => props.modelValue,
  () => {
    vhtml.value = props.modelValue
  },
  { immediate: true }
)
watch(
  () => vhtml.value,
  () => {
    emit('update:modelValue', vhtml.value)
    emit('change', vhtml.value)
  },
  { immediate: true }
)
</script>
